export default __webpack_public_path__ + "static/media/anonymus.43450fa0.svg";